"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _attendee = require("../../../actions/attendee");
function attendeeCameraRemoved(_ref, _ref2) {
  var dispatch = _ref.dispatch;
  var attendeeId = _ref2.attendeeId,
    isCameraOn = _ref2.isCameraOn;
  dispatch((0, _attendee.setAttendeeCameraStatus)(attendeeId, isCameraOn));
}
var _default = exports["default"] = attendeeCameraRemoved;